import { getCookie, getCookieParam } from '../helpers/cookie';

export default {
    data() {
        return {
            isYoutubeAuthorized: false
        }
    },
    mounted() {
        const cookie = getCookie('tarteaucitron');
        this.isYoutubeAuthorized = getCookieParam(cookie, 'youtube') !== 'false';
    }
};
